<template>
    <div>
        <div class="uk-flex uk-flex-column uk-margin-large-top uk-margin-medium-bottom">
            <div :class="noAcceptTerms">
                <label for="agb">
                    <input
                        class="uk-checkbox"
                        type="checkbox"
                        value="acceptTerms"
                        v-model="acceptTerms"
                        id="agb"
                    />
                    {{ $t("Ich habe die") }}
                    <a :href="settings.custom_terms_url" class="uk-link-muted uk-text-danger" target="_blank">
                        {{ $t("AGB") }}
                    </a>
                    {{ $t("gelesen und akzeptiert.") }}
                </label>
            </div>

            <div :class="noAcceptPrivacy">
                <label for="datenschutz">
                    <input
                        class="uk-checkbox"
                        type="checkbox"
                        value="acceptPrivacy"
                        v-model="acceptPrivacy"
                        id="datenschutz"
                    />
                    {{ $t("Ich habe die") }}
                    <a
                        class="uk-link-muted uk-text-danger"
                        :href="settings.linkToPrivacy"
                        target="_blank"
                    >
                        {{ $t("Datenschutzerklärung") }}
                    </a>
                    {{ $t("gelesen und akzeptiert.") }}
                </label>
            </div>
            <div class="alert-AGB" v-if="showAgbHint">{{ $t("Bitte überprüfe die AGBs") }}</div>
        </div>
    </div>
</template>

<script>
import helper from "../../helper/helper";
import useVuelidate from "@vuelidate/core";
import { sameAs } from 'vuelidate/lib/validators'

export default {
    mixins: [helper],
    props: ['settings'],
    components: {},
    data: () => {
        return {
            v$: useVuelidate(),
            acceptTerms: false,
            acceptPrivacy: false,
        }
    },
    validations: {
        acceptTerms: { sameAs: sameAs( () => true ) },
        acceptPrivacy: { sameAs: sameAs( () => true ) },
    },
    computed: {
        showAgbHint() {
            return this.v$.$dirty && this.v$.$error;
        },
        noAcceptTerms() {
            return {
                invalid: this.v$.acceptTerms.$dirty && this.v$.acceptTerms.$error,
            };
        },
        noAcceptPrivacy() {
            return {
                invalid: this.v$.acceptPrivacy.$dirty && this.v$.acceptPrivacy.$error,
            };
        },
    },
    mounted() {
    },
    methods: {
        validate() {
            this.v$.$touch();
            return !this.v$.$invalid;
        },
    }
}
</script>
